// action
import {
    SAVE_PREGNANCY_HIGHLIGHTS,
    SAVE_PREGNANCY_HIGHLIGHTS_FAIL,
    SAVE_PREGNANCY_HIGHLIGHTS_SUCCESS,
    SAVE_PREGNANCY_HIGHLIGHTS_RESET
} from '../action/savePregnancyHighlightsAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SAVE_PREGNANCY_HIGHLIGHTS:
            return {
                ...state,
                apiState: "loading"
            }
        case SAVE_PREGNANCY_HIGHLIGHTS_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case SAVE_PREGNANCY_HIGHLIGHTS_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case SAVE_PREGNANCY_HIGHLIGHTS_RESET:
            return initialState
        default:
            return state
    }
}